// extracted by mini-css-extract-plugin
module.exports = {"bufferGraph":"styles_bufferGraph__2f-eJ","bufferArea":"styles_bufferArea__2UVle","bufferIndicator":"styles_bufferIndicator__2_J4E"};